import React, { useEffect, useState } from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Button,
  Alert,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import GlobalWrapper from '../../../../../components/Wrapper/GlobalWrapper';
import { useLocation } from 'react-router-dom';
import { Form, FormikProvider, useFormik } from 'formik';
import dayjs from 'dayjs';
import { useSnackbar } from 'notistack';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Icon } from '@iconify/react/dist/iconify.js';
import {
  getAttendanceTypes,
  getBatchStudents,
  getbatchtopics,
  getsmeTopics,
  getStudentsUnderBatch,
  markAttendance,
} from '../../../../../redux/features/batchSlice';
import * as Yup from 'yup';

const MarkAttendance = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading, batchTopics, batchStudents, smeTopics, attendanceTypes } = useSelector((state) => state.batch);
  const [value, setValue] = useState(dayjs());
  const [students, setStudents] = useState([]);

  const location = useLocation();

  const { batchdata } = location.state || {};

  const ValidationSchema = Yup.object().shape({
    session_schedule_id: Yup.string().required('Please choose scheduled session'),
    attendance_type: Yup.string().required('Please choose attendance type'),
    from_time: Yup.string().nullable().required('From Time is required'),
    to_time: Yup.string().nullable().required('To Time is required'),
  });

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: ValidationSchema,
    initialValues: {
      attendance_type: '',
      session_schedule_id: '',
      academic_calendar_id: '' || null,
      from_time: null,
      to_time: null,
      trainer_id: batchdata?.trainer_id || '',
      trainer_assignment_id: batchdata?.trainer_assignment_id || '',
      lessons: '',
      trainer_remarks: '',
      attendance: Array(students.length).fill('Present'),
    },
    onSubmit: (values) => {
      const fromTime = values.from_time ? dayjs(values.from_time).format('HH:mm:ss') : null;
      const toTime = values.to_time ? dayjs(values.to_time).format('HH:mm:ss') : null;

      const attendanceObject = students.reduce((acc, s, i) => {
        acc[s.batch_assignment_id] = values.attendance[i] || 'N/A';
        return acc;
      }, {});

      const payload = {
        ...values,
        from_time: fromTime,
        to_time: toTime,
        attendance: attendanceObject,
      };

      dispatch(markAttendance(payload)).then((res) => {
        if (res.payload.status === 'success') {
          enqueueSnackbar(res.payload.message, { variant: 'success' });
          formik.resetForm();
        } else {
          enqueueSnackbar(res.payload.message, { variant: 'error' });
        }
      });
    },
  });

  const data = {
    batch_id: batchdata?.course_batch_id,
    subject_id: batchdata?.subject_enrollment_id || null,
  };

  useEffect(() => {
    if (batchdata) {
      dispatch(getbatchtopics(data));
      dispatch(
        getsmeTopics({ subject_enrollment_id: batchdata?.subject_enrollment_id, batchID: batchdata?.course_batch_id })
      );
      dispatch(getAttendanceTypes());
    }
  }, []);

  const batch_ids = batchdata?.course_batch_id;

  useEffect(() => {
    if (batchdata) {
      dispatch(getStudentsUnderBatch({ batch_ids })).then((res) => {
        if (res.payload?.status === 'success') {
          setStudents(res.payload.data || []);
        } else {
          setStudents([]);
        }
      });
    } else {
      setStudents([]);
    }
  }, []);

  return (
    <GlobalWrapper title={'Batch Attendance'}>
      <Box sx={{ width: '100%', padding: 0 }}>
        <Stack
          direction={{
            xs: 'column',
            sm: 'row',
          }}
          spacing={1}
          paddingBottom={3}
        >
          <Box
            sx={{
              backgroundImage: 'linear-gradient(to right,#a125c2,#a125c2)',
              px: '20px',
              py: '10px',
              borderRadius: '15px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontSize: '16px',
            }}
          >
            Batch : {`${batchdata?.course_batch_serial_no} - ${batchdata?.course_batch_name}`}
          </Box>
          <Box
            sx={{
              backgroundImage: 'linear-gradient(to right,#a125c2,#a125c2)',
              px: '20px',
              py: '10px',
              borderRadius: '15px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontSize: '16px',
            }}
          >
            Course : {batchdata?.course_name}
          </Box>
          <Box
            sx={{
              backgroundImage: 'linear-gradient(to right,#a125c2,#a125c2)',
              px: '20px',
              py: '10px',
              borderRadius: '15px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontSize: '16px',
            }}
          >
            Subject : {batchdata?.subject_name}
          </Box>
        </Stack>
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} paddingBottom={2}>
              <Box sx={{ width: '100%', flexDirection: 'column', display: 'flex', gap: '5px' }}>
                <FormControl fullWidth>
                  <InputLabel>Scheduled Session</InputLabel>
                  <Select
                    fullWidth
                    label="Scheduled Session"
                    name="session_schedule_id"
                    value={formik.values.session_schedule_id}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  >
                    {batchTopics?.map((session) => {
                      const weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                      const dayName = weekDays[session.week_day];

                      return (
                        <MenuItem key={session.session_schedule_id} value={session.session_schedule_id}>
                          {`${session.session_date} - ${dayName} (${session.from_time} - ${session.to_time})`}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
                {formik.errors.session_schedule_id && formik.touched.session_schedule_id && (
                  <Typography variant="caption" color="error">
                    {formik.errors.session_schedule_id}
                  </Typography>
                )}
              </Box>
              {students?.length > 0 && (
                <FormControl fullWidth>
                  <InputLabel>Topic</InputLabel>
                  <Select
                    fullWidth
                    label="Topic"
                    name="academic_calendar_id"
                    value={formik.values.academic_calendar_id}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  >
                    {smeTopics?.map((val) => (
                      <MenuItem key={val.sme_schedules_topic_id} value={val.sme_schedules_topic_id}>
                        {val.topic}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
              <Box sx={{ width: '100%', flexDirection: 'column', display: 'flex', gap: '5px' }}>
                <FormControl fullWidth>
                  <InputLabel>Attendance Type</InputLabel>
                  <Select
                    fullWidth
                    label="Attendance Type"
                    name="attendance_type"
                    value={formik.values.attendance_type}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  >
                    {attendanceTypes?.map((type) => (
                      <MenuItem key={type.attendance_type_id} value={type.attendance_type_id}>
                        {type.attendance_type_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {formik.errors.attendance_type && formik.touched.attendance_type && (
                  <Typography variant="caption" color="error">
                    {formik.errors.attendance_type}
                  </Typography>
                )}
              </Box>
            </Stack>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} paddingBottom={2}>
              <Box sx={{ width: '100%', flexDirection: 'column', display: 'flex', gap: '5px' }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    name="from_time"
                    label="Start Time"
                    ampm={false}
                    value={formik.values.from_time}
                    onChange={(newValue) => formik.setFieldValue('from_time', newValue)}
                    onBlur={() => formik.setFieldTouched('from_time', true)}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        onKeyDown: (e) => e.preventDefault(),
                        error: formik.touched.from_time && Boolean(formik.errors.from_time),
                        helperText: formik.touched.from_time && formik.errors.from_time,
                      },
                    }}
                  />
                </LocalizationProvider>
              </Box>
              <Box sx={{ width: '100%', flexDirection: 'column', display: 'flex', gap: '5px' }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    name="to_time"
                    label="End Time"
                    ampm={false}
                    value={formik.values.to_time}
                    onChange={(newValue) => formik.setFieldValue('to_time', newValue)}
                    onBlur={() => formik.setFieldTouched('to_time', true)}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        onKeyDown: (e) => e.preventDefault(),
                        error: formik.touched.to_time && Boolean(formik.errors.to_time),
                        helperText: formik.touched.to_time && formik.errors.to_time,
                      },
                    }}
                  />
                </LocalizationProvider>
              </Box>
            </Stack>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} paddingBottom={2}>
              <TextField
                fullWidth
                label="Lesson(s)/Topics"
                name="lessons"
                placeholder="Enter the Notes/Remarks *"
                multiline
                rows={3}
                value={formik.values.lessons_remarks}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.lessons_remarks && Boolean(formik.errors.lessons_remarks)}
                helperText={formik.touched.lessons_remarks && formik.errors.lessons_remarks}
              />
              <TextField
                fullWidth
                label="Trainer Remarks"
                name="trainer_remarks"
                multiline
                placeholder="Enter the Notes/Remarks"
                rows={3}
                value={formik.values.trainer_remarks}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.trainer_remarks && Boolean(formik.errors.trainer_remarks)}
                helperText={formik.touched.trainer_remarks && formik.errors.trainer_remarks}
              />
            </Stack>
            {students?.length === 0 && (
              <Alert variant="outlined" severity="info" mb={2}>
                No students assigned to this batch.
              </Alert>
            )}
            {students?.length > 0 && (
              <Box sx={{ mt: 3 }}>
                <Typography variant="subtitle2" mb={2}>
                  Student Attendance
                </Typography>

                <TableContainer component={Paper} sx={{ mt: 2 }}>
                  <Table
                    stickyHeader
                    size="small"
                    sx={{
                      '& .MuiTableCell-root': {
                        borderRight: '1px solid #e0e0e0',
                      },
                      '& .MuiTableCell-root:last-child': {
                        borderRight: 'none',
                      },
                    }}
                  >
                    <TableHead
                      sx={{
                        '& .MuiTableCell-root': {
                          backgroundColor: '#c6c6c6ff',
                          fontWeight: 600,
                          py: 2,
                        },
                      }}
                    >
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600 }}>Sl. No</TableCell>
                        <TableCell sx={{ fontWeight: 600 }}>Student Name</TableCell>
                        <TableCell sx={{ fontWeight: 600 }}>Attendance</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {students?.map((student, index) => (
                        <TableRow key={student.batch_assignment_id}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{student.studentName}</TableCell>
                          <TableCell>
                            <FormControl fullWidth size="small">
                              <Select
                                name={`attendance[${index}]`}
                                value={formik.values.attendance[index]}
                                onChange={(e) => formik.setFieldValue(`attendance[${index}]`, e.target.value)}
                              >
                                <MenuItem value="Present">Present</MenuItem>
                                <MenuItem value="Absent">Absent</MenuItem>
                                <MenuItem value="N/A">N/A</MenuItem>
                              </Select>
                            </FormControl>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )}
            {students?.length > 0 && (
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mt: 2,
                }}
              >
                <Button
                  type="submit"
                  disabled={loading}
                  color="secondary"
                  startIcon={<Icon icon={'fa7-solid:save'} />}
                  variant="contained"
                >
                  {loading ? 'Submitting...' : 'Submit Attendance'}
                </Button>
              </Box>
            )}
          </Form>
        </FormikProvider>
      </Box>
    </GlobalWrapper>
  );
};

export default MarkAttendance;
